export default async function ({ store, redirect, app }) {
  await app.$api.auth.use('data').logout()
  await store.dispatch('FETCH_SESSION')
  return redirect(app.localePath({ name: 'index' }))
}
